"use client";
import React, { useState } from "react";
import Image from "next/image";
import ImageModal from "./ImageModal";

type Props = {
    filename: string;
    imageSrcTemplate: (filename: string) => string;
};

const GenericImage: React.FC<Props> = ({ filename, imageSrcTemplate }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!filename) return null;

    const src = imageSrcTemplate(filename);

    return (
        <div className="w-full overflow-hidden">
            <div
                className="group relative h-40 w-40 cursor-pointer overflow-hidden rounded-md"
                onClick={() => setIsModalOpen(true)}
            >
                <Image
                    src={src}
                    alt={filename}
                    objectFit="cover"
                    layout="fill"
                    className="group-hover:border-2 group-hover:border-emerald-500"
                />
            </div>
            {isModalOpen && (
                <ImageModal
                    src={src}
                    alt={filename}
                    onNext={() => {}}
                    onPrevious={() => {}}
                    onClose={() => setIsModalOpen(false)}
                />
            )}
        </div>
    );
};

export default GenericImage;
